/* @flow weak */
export const IdentityVerification = {
  title: 'Verify your information to keep your funds safe',
  subtext: `Verification helps us make sure that we're moving money to the right person and account.
    This information will only be used to protect your funds.`,
};

export const BankAccount = {
  title: 'Add a bank account',
  subtext: `Request approval to send activity funds to an official school bank account. If you do
    not have a school account, you can always deposit funds into an individual bank account.`,
};

export const TreasurerSignUp = {
  title: 'Money collection built for schools',
  h1: 'Hassle-free. Never deal with bounced checks or envelopes of cash again.',
  h2: 'Approve staff requests to deposit funds directly to your school bank account.',
  h3: 'Keep information secure and protected with bank-level payment solutions.',
};

export const TreasurerAddBankAccount = {
  title: 'Approve request to deposit funds to your school bank account',
};

export const RequestBankAccountConfirmation = {
  title: 'Request sent',
  subtext: `You’ll be notified when your account administrator approves your request.
    Once that's done, you’ll be able to deposit funds directly to your school bank account.`,
};

export const AddSchoolAccount = {
  defaultNote1: 'I’m using Remind to organize a class activity, and I’d like to share our activity',
  defaultNote2: 'and transaction details with you. You can set up our school bank account on',
  defaultNote3: 'Remind, and if you approve, I can transfer activity funds directly into that',
  defaultNote4: 'account without seeing any confidential information.',
  defaultNote5: 'Please let me know if you have any questions. Thanks!',
};

export const CreateEventCostEducation = {
  title1: 'Collect money effortlessly',
  subheader1: `Activity participants can send money online. All major credit and debit cards are
    accepted.`,
  title2: 'Automatically track who’s paid',
  subheader2: 'Access this list from anywhere and share reminders when you need to.',
  title3: 'Deposit to any bank account',
  subheader3: 'Transfer activity funds to your school’s bank account or an individual account.',
};

export const CreateEventEducation = {
  header: 'It’s easier than ever to coordinate activities at your school.',
  subheader1: 'Let people know about upcoming events and track who’s coming.',
  subheader2: 'Collect funds online so you don’t have to worry about cash and checks.',
  subheader3: 'Request admin approval to deposit money safely to your school’s bank account.',
};

export const ActivityAgeConfirmation = {
  title: 'The organizer would love to know more about you',
  subtext: `The below information will help your organizer better plan and manage this activity.
    Thanks!`,
};



// WEBPACK FOOTER //
// ./src/payments/constants/CopyConstants.js